import React from 'react';
import RTCCard from './RTCCard';
import PrivateBusCard from './PrivateBusCard';

const Listing = (props) => {
    const { rtcBuses, privateBuses, moveToFunnel, src_dump, showClientContent, showHeading} = props;

    return (
        <>
            <table className="listingTableSection">
                {showHeading ? <thead className="desktopOnly tableHeading">
                    <tr className="makeFlex">
                        <th className="busDetails" align="left">Bus Details</th>
                        <th style={{ width: "316px" }} align="left">Time and Duration</th>
                        {!src_dump ? <th style={{ width: "216px" }} align="left">Price</th> : null}
                        <th></th>
                    </tr>
                </thead> : null}
                <tbody>
                    {rtcBuses && Object.keys(rtcBuses).length ? <RTCCard rtcBuses={rtcBuses} moveToFunnel={moveToFunnel} showClientContent={showClientContent}></RTCCard> : null}
                    {privateBuses && privateBuses.length ? <PrivateBusCard privateBuses={privateBuses} moveToFunnel={moveToFunnel}></PrivateBusCard> : null}
                </tbody>
            </table>
        </>
    )
}

export default Listing;
